// extracted by mini-css-extract-plugin
export var mainVideoContainer = "style-mod--main-video-container--b0666";
export var modal = "style-mod--modal--5583b";
export var modalClose = "style-mod--modal-close--4b9bb";
export var modalContainer = "style-mod--modal-container--862bb";
export var title = "style-mod--title--f6994";
export var video = "style-mod--video--42a7f";
export var videoContainer = "style-mod--video-container--b4a66";
export var videoModal = "style-mod--video-modal--64755";
export var viewButton = "style-mod--view-button--0853a";